import http from '@/services'

class IsetService {
  constructor() {
    this._baseURL =
      (localStorage.getItem('API_URL') ||
        process.env.VUE_APP_BASEURL ||
        'http://localhost:8000/api/') + 'iset/'
        
    }
    
    hasParameter(string) {
        if (string.substr(string.length - 1) === '?') return false
        return true
    }
      
    createRequestUrl(url, payload){
        let requestUrl = `${url}?`

        if(payload && payload.categoriaPai)
            requestUrl += this.hasParameter(requestUrl) ? 
            `&PARENT_ID=${payload.categoriaPai}` : `PARENT_ID=${payload.categoriaPai}`
        if(payload && payload.id)
            requestUrl += this.hasParameter(requestUrl) ? 
            `&id=${payload.id}` : `id=${payload.id}`
        if(payload && payload.todos)
            requestUrl += this.hasParameter(requestUrl) ?
            `&TODOS=${payload.todos}` : `TODOS=${payload.todos}`
        if(payload && payload.integrados)
            requestUrl += this.hasParameter(requestUrl) ?
            `&INTEGRADOS=${payload.integrados}` : `INTEGRADOS=${payload.integrados}`
        if(payload && payload.categoryId)
            requestUrl += this.hasParameter(requestUrl) ? 
            `&CATEGORY=${payload.categoryId}` : `CATEGORY=${payload.categoryId}`
        if(payload && payload.stockLessThen)
            requestUrl += this.hasParameter(requestUrl) ?
            `&ESTOQUEMENORQUE=${payload.stockLessThen}`: `ESTOQUEMENORQUE=${payload.stockLessThen}`
        
        return requestUrl
    }
    
    async login(){
        let requestUrl = `${this._baseURL}auth/`
        return await http.post(requestUrl)
    }

    // Categorias
    async getCategories(payload = {}){
        let requestUrl = this.createRequestUrl(`${this._baseURL}categories`, payload)
        return await http.get(requestUrl);
    }

    async getCategoriesIntegration(payload = {}){
        let requestUrl = this.createRequestUrl(`${this._baseURL}categories/index-gestao`, payload)
        return await http.get(requestUrl)
    }

    async getCategoryIntegration(payload){
        let requestUrl = `${this._baseURL}categories/gestao/${payload}`
        return await http.get(requestUrl)
    }

    async getCategory(id){
        let requestUrl = `${this._baseURL}categories/${id}`
        return await http.get(requestUrl)
    }

    async integrateCategories(payload){
        let requestUrl = `${this._baseURL}categories/integrate`;
        return await http.post(requestUrl, payload)
    }
    
    async forceSinchronization(){
        let requestUrl = `${this._baseURL}categories/verify`
        return await http.get(requestUrl)
    }

    //Clientes
    async getAddresses(payload){
        let requestUrl = this.createRequestUrl(`${this._baseURL}customer`, payload)
        return await http.get(requestUrl)
    }
    

    //Produtos
    async getProducts(payload = {}){
        let requestUrl = this.createRequestUrl(`${this._baseURL}product`, payload)
        return await http.get(requestUrl)
    }

    async getProduct(id){
        let requestUrl = `${this._baseURL}product/${id}`
        return await http.get(requestUrl)
    }

    async insertProduct(payload){
        let requestUrl = `${this._baseURL}product`
        return await http.post(requestUrl, {id: payload})
    }

    async updateProduct(payload, id){
        let requestUrl = `${this._baseURL}/${id}`
        return await http.post(requestUrl, payload)
    }

    async integrateProducts(payload){
        let requestUrl = `${this._baseURL}product/integrate`
        return await http.post(requestUrl, payload)
    }

    async clearStock(){
        let requestUrl = `${this._baseURL}product/clear-stock`
        return await http.get(requestUrl)
    }

    async verifyStock(){
        let requestUrl = `${this._baseURL}product/verify-stock`
        return await http.get(requestUrl)
    }

    //Fabricantes
    async getManufacturers(payload = {}){
        let requestUrl = this.createRequestUrl(`${this._baseURL}manufacturers`, payload)
        return await http.get(requestUrl)
    }

    async integrateManufacturers(payload){
        let requestUrl = `${this._baseURL}manufacturers/integrate`
        return await http.post(requestUrl, payload)
    }

    //Pedidos
    async getPedidos(payload = {}) {
        let requestUrl = this.createRequestUrl(`${this._baseURL}order`, payload)
        return await http.get(requestUrl)
    }

    async getPedido(id){
        let requestUrl = `${this._baseURL}order/${id}`
        return await http.get(requestUrl)
    }
    //conversores


    // comentado sem uso
    // async convertCategory(payload){
    //     let newCategory = {
    //         ID: payload.id,
    //         NOME: payload.title,
    //         SUBTITULO: payload.subtitle,
    //         PARENT_ID: payload.parent_id,
            
    //     }
    // }

    // Sinconismo

    async getSynchronizationLog(payload){
        let requestUrl = this.createRequestUrl(`${this._baseURL}logs`, payload)
        return await http.get(requestUrl)
    }
}
export default new IsetService()
